var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "py-2" }, [
    _c("div", { staticClass: "row" }, [
      _vm._m(0),
      _c("div", { staticClass: "col-12 mx-4" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-sm" }, [
            _c("span", { staticClass: "data-label" }, [_vm._v("Impedimento:")]),
            _c("p", { staticClass: "data" }, [
              _vm._v(_vm._s(_vm.value.impediment || "-"))
            ])
          ]),
          _c("div", { staticClass: "col-sm" }, [
            _c("span", { staticClass: "data-label" }, [_vm._v("Escuela:")]),
            _c("p", { staticClass: "data" }, [
              _vm._v(
                _vm._s(_vm.value.schoolCode) + " - " + _vm._s(_vm.value.school)
              )
            ])
          ])
        ])
      ]),
      _vm._m(1),
      _c("div", { staticClass: "col-12 mx-4" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-sm-12 col-md-6 col-lg-3" }, [
            _c("span", { staticClass: "data-label" }, [_vm._v("Desde:")]),
            _c("p", { staticClass: "data" }, [
              _vm._v(_vm._s(_vm._f("date")(_vm.value.dateFrom)))
            ])
          ]),
          _c("div", { staticClass: "col-sm-12 col-md-6 col-lg-3" }, [
            _c("span", { staticClass: "data-label" }, [_vm._v("Inicial:")]),
            _c("p", { staticClass: "data" }, [
              _vm._v(_vm._s(_vm._f("date")(_vm.value.initialDate)))
            ])
          ]),
          _c("div", { staticClass: "col-sm-12 col-md-6 col-lg-3" }, [
            _c("span", { staticClass: "data-label" }, [_vm._v("Proveedor:")]),
            _c("p", { staticClass: "data" }, [
              _vm._v(_vm._s(_vm.value.providerName || "-"))
            ])
          ])
        ]),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-sm-12 col-md-6 col-lg-3" }, [
            _c("span", { staticClass: "data-label" }, [_vm._v("Hasta:")]),
            _c("p", { staticClass: "data" }, [
              _vm._v(_vm._s(_vm._f("date")(_vm.value.dateTo)))
            ])
          ]),
          _c("div", { staticClass: "col-sm-12 col-md-6 col-lg-3" }, [
            _c("span", { staticClass: "data-label" }, [_vm._v("Admisión:")]),
            _c("p", { staticClass: "data" }, [
              _vm._v(_vm._s(_vm._f("date")(_vm.value.admissionDate)))
            ])
          ]),
          _c("div", { staticClass: "col-sm-12 col-md-6 col-lg-3" }, [
            _c("span", { staticClass: "data-label" }, [
              _vm._v("Lugar de Servicio:")
            ]),
            _c("p", { staticClass: "data" }, [
              _vm._v(_vm._s(_vm.value.locationName || "-"))
            ])
          ])
        ]),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-sm-12 col-md-6 col-lg-3" }, [
            _c("span", { staticClass: "data-label" }, [_vm._v("Referido:")]),
            _c("p", { staticClass: "data" }, [
              _vm._v(_vm._s(_vm._f("date")(_vm.value.referralDate)))
            ])
          ]),
          _c("div", { staticClass: "col-sm-12 col-md-6 col-lg-3" }, [
            _c("span", { staticClass: "data-label" }, [
              _vm._v("Última visita:")
            ]),
            _c("p", { staticClass: "data" }, [
              _vm._v(_vm._s(_vm._f("date")(_vm.value.lastDateVisit)))
            ])
          ]),
          _c("div", { staticClass: "col-sm-12 col-md-6 col-lg-3" }, [
            _c("span", { staticClass: "data-label" }, [
              _vm._v("Especialista de Admisión:")
            ]),
            _c("p", { staticClass: "data" }, [
              _vm._v(_vm._s(_vm.value.admissionSpecialist || "-"))
            ])
          ])
        ]),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-sm-12 col-md-6 col-lg-3" }, [
            _c("span", { staticClass: "data-label" }, [_vm._v("Vinculado:")]),
            _c("p", { staticClass: "data" }, [
              _vm._v(_vm._s(_vm._f("date")(_vm.value.linkedDate)))
            ])
          ]),
          _c("div", { staticClass: "col-sm-12 col-md-6 col-lg-3" }, [
            _c("span", { staticClass: "data-label" }, [_vm._v("Contacto:")]),
            _c("p", { staticClass: "data" }, [
              _c("label", [
                _vm._v(" " + _vm._s(_vm.value.contact) + " "),
                _c("br"),
                _vm._v(" " + _vm._s(_vm.value.contactTelephone) + " "),
                _c("br"),
                _vm._v(" " + _vm._s(_vm.value.contactEmail) + " ")
              ])
            ])
          ]),
          !_vm.hasPilotPermission
            ? _c("div", { staticClass: "col-sm-12 col-md-6 col-lg-3" }, [
                _c("span", { staticClass: "data-label" }, [
                  _vm._v(" Especialista de Servicio Asignado: ")
                ]),
                _c("p", { staticClass: "data" }, [
                  _vm._v(_vm._s(_vm.value.serviceSpecialist || "-"))
                ])
              ])
            : _vm._e()
        ]),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-sm-12 col-md-6 col-lg-3" }, [
            _c("span", { staticClass: "data-label" }, [
              _vm._v("Tipo de Referido:")
            ]),
            _c("p", { staticClass: "data" }, [
              _vm._v(_vm._s(_vm.value.admissionCreationReason))
            ])
          ])
        ])
      ]),
      _vm.hasPilotPermission
        ? _c("div", { staticClass: "container-fluid" }, [
            _vm._m(2),
            _c("div", [
              _c("div", { staticClass: "row pl-4" }, [
                _c("div", { staticClass: "col-sm-12 col-md-6 col-lg-2" }, [
                  _c("span", { staticClass: "data-label" }, [
                    _vm._v("Tipo de Lugar:")
                  ]),
                  _c("p", { staticClass: "data" }, [
                    _vm._v(_vm._s(_vm.value.locationTypeName || "-"))
                  ])
                ]),
                _c("div", { staticClass: "col-sm-12 col-md-6 col-lg-2 ml-3" }, [
                  _c("span", { staticClass: "data-label" }, [
                    _vm._v("Municipio:")
                  ]),
                  _c("p", { staticClass: "data" }, [
                    _vm._v(_vm._s(_vm.value.municipality || "-"))
                  ])
                ]),
                _c("div", { staticClass: "col-sm-12 col-md-6 col-lg-2" }, [
                  _c("span", { staticClass: "data-label" }, [
                    _vm._v("Región:")
                  ]),
                  _c("p", { staticClass: "data" }, [
                    _vm._v(_vm._s(_vm.value.region || "-"))
                  ])
                ]),
                _c("div", { staticClass: "col-sm-12 col-md-6 col-lg-2" }, [
                  _c("span", { staticClass: "data-label" }, [
                    _vm._v("Escuela:")
                  ]),
                  _c("p", { staticClass: "data" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm.value.schoolCode || "-") +
                        " - " +
                        _vm._s(_vm.value.school) +
                        " "
                    )
                  ])
                ])
              ]),
              _c("div", { staticClass: "row pl-4" }, [
                _c("div", { staticClass: "col-sm-12 col-md-6 col-lg-3" }, [
                  _c("span", { staticClass: "data-label" }, [
                    _vm._v(" Especialista de Servicio Asignado: ")
                  ]),
                  _c("p", { staticClass: "data" }, [
                    _vm._v(_vm._s(_vm.value.serviceSpecialist || "-"))
                  ])
                ]),
                _c("div", { staticClass: "col-sm-12 col-md-6 col-lg-3" }, [
                  _c("span", { staticClass: "data-label" }, [
                    _vm._v("Practicante:")
                  ]),
                  _c("p", { staticClass: "data" }, [
                    _vm._v(_vm._s(_vm.value.practitioner || "-"))
                  ])
                ])
              ]),
              _c(
                "div",
                { staticClass: "row pl-4" },
                [
                  _c("label", { staticClass: "data-label col-md-12" }, [
                    _vm._v("Día/Hora:")
                  ]),
                  _vm._l(_vm.value.serviceDays, function(day) {
                    return _c(
                      "div",
                      {
                        key: day.id,
                        staticClass: "col-sm-12 col-md-6 col-lg-2",
                        staticStyle: { display: "inline-block" }
                      },
                      [
                        _c("span", { staticClass: "data" }, [
                          _vm._v(_vm._s(_vm.formatToWeekDay(day.day)) + ":")
                        ]),
                        _c("p", { staticClass: "data font-weight-bold" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.formatHours(day.starDate, day.endTime)
                              ) +
                              " "
                          )
                        ])
                      ]
                    )
                  })
                ],
                2
              )
            ])
          ])
        : _vm._e(),
      _c("div", { staticClass: "col-12 mx-4" }, [
        _c("span", { staticClass: "data-label" }, [
          _vm._v("Razón de Servicio:")
        ]),
        _c("p", { staticClass: "data" }, [
          _vm._v(_vm._s(_vm._f("empty")(_vm.value.serviceReason)))
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-12 mb-3" }, [
      _c("em", { staticClass: "fas fa-info-circle text-orange mr-1" }),
      _c("span", [_vm._v("Información del Estudiante")])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-12 mb-3" }, [
      _c("em", { staticClass: "fas fa-info-circle text-orange mr-1" }),
      _c("span", [_vm._v("Información de Servicio")])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-12 mb-3" }, [
      _c("em", { staticClass: "fas fa-info-circle text-orange mr-1" }),
      _c("span", [_vm._v("Lugar de Servicio donde se recibirá el servicio")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }